import React from 'react';
import {observer} from 'mobx-react';
import {Modal} from 'shared/components/modals';
import {HtmlRender} from 'shared/components';

const CandidateEmailModal = observer(({uiState}) => {
  const {detailsState} = uiState;
  const {openedEmail} = detailsState;

  return (
    <Modal
      isOpen={detailsState.emailModalOpen}
      title={openedEmail.subject}
      size='lg'
      translateTitle={false}
      onHide={() => detailsState.closeEmailModal()}
    >
      <HtmlRender html={openedEmail.body}/>
    </Modal>
  );
});

export default CandidateEmailModal;
